<template>
    <div class="license-tile">
        <div class="license-tile__background">
            <div class="license-tile__background-skyline">
                <a :href="linkPrimary">
                    <div class="license-tile__background-image-wrapper">
                        <img :src="image" class="license-tile__background-image"/>
                    </div>
                </a>
            </div>
        </div>

        <div class="license-tile__title">
            {{ title }}
        </div>

        <div class="license-tile__body">
            {{ body }}
        </div>

        <div class="license-tile__links">
            <span></span>

            <a :href="linkPrimary" class="btn btn--primary">
                {{ titleLinkPrimary }}
            </a>
        </div>
    </div>

</template>

<script>
export default {
    props: [
        'linkPrimary',
        'titleLinkPrimary',
        'linkSecondary',
        'titleLinkSecondary',
        'image',
        'title',
        'body',
    ]
}
</script>
